<esp-deposit-free-text [autoPopulated]="isAutoPopulated"
                       [freeText]="depositFormDataService.technicalInformation"
                       placeholder="{{'research.technical.text' | customTranslate}}">
</esp-deposit-free-text>

